/**
 * Session management utilities for storing and retrieving API key from sessionStorage.
 * Session is cleared when browser tab closes.
 */

const SESSION_KEY = "payments_auth_api_key";

export interface SessionData {
  apiKey: string;
  timestamp: number;
}

/**
 * Store API key in session storage
 */
export function setSession(apiKey: string): void {
  const data: SessionData = {
    apiKey,
    timestamp: Date.now(),
  };
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
}

/**
 * Retrieve API key from session storage
 */
export function getSession(): string | null {
  const stored = sessionStorage.getItem(SESSION_KEY);
  if (!stored) {
    return null;
  }

  try {
    const data: SessionData = JSON.parse(stored);
    return data.apiKey;
  } catch {
    // Invalid JSON, clear session
    clearSession();
    return null;
  }
}

/**
 * Clear session storage
 */
export function clearSession(): void {
  sessionStorage.removeItem(SESSION_KEY);
}

/**
 * Check if user has active session
 */
export function hasSession(): boolean {
  return getSession() !== null;
}
